import axios from "axios";
import { ORDER_API } from "../constants/apiUrls";
export const getFreeImageApi = async (data) => {
  
  const response = await axios.get(`${ORDER_API}/image/free/ceo`, {
    params: data,
    headers: { Authorization: `Bearer ceo` }
  });

  return response.data;
}



/**
 * 이하 함수는 서버 대상 식별 불가
 * 함수 내부 주석처리
 * 
 * @date 2026-04-17
 * @author Saccharin01
 */

export const getNewFreeImageApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/free-images`, {
  //   params: data,
  //   headers: { Authorization: `Bearer ${accessToken}` }
  // });

  // return response.data;
}